import React, { useState, useEffect } from 'react';
import { useSelector, connect } from 'react-redux';
import { changeStepForm, changeTypeCar, changeTypeRedirect, STEPS } from '../../redux/actions/PasosFormulario';
import { reset as resetForm } from 'redux-form';
import { reset } from '../../redux/actions/Coberturas';
import Label from '../utils/Label';
import RowVehiculo from '../utils/RowVehiculo';
import '../../sass/FormVehiculo.scss';
import { isLoading } from '../../redux/actions/Loading';


let FormVehiculos = ({ stepFoward, changeCar, bindReset }) => {

    const { stepForm, typeCar, stepActive } = useSelector(state => state.pasosReservacion);
    const vehiculo = useSelector(state => state.vehiculo);
    const categoriasVehiculos = useSelector(state => state.categoriaVehiculosCatalogo);
    
    const [idCategoria, setIdCategoria] = useState(vehiculo.Id ? vehiculo.Categoria.Id : (categoriasVehiculos.length > 0 && categoriasVehiculos[0].Id))
    const [carOption, setCarOption] = useState([]);
    const [showSiguiente, setShowSiguiente] = useState(false);
    const { FechaRecepcion, FechaDevolucion } = useSelector(state => state.reservacion);
    window.scrollTo(0, 0);

    useEffect(() => {
        
        setIdCategoria(typeCar);
        setCarOption(categoriasVehiculos.map((categoria) =>
            <option key={categoria.Id} value={categoria.Id}>{categoria.Nombre}</option>

        ));
    }, [typeCar]);

    useEffect(() => {
        //console.log(" ACTIVE : " + vehiculo.nombre?true:false);s
        //console.log(vehiculo);
        //console.log(stepActive);
        //setShowSiguiente(vehiculo.nombre?true:false);
        setShowSiguiente(stepActive.stepCoberturas);
        //console.log(showSiguiente);
    }, [stepActive]);
    /*
        const optionsVehiculos = categoriasVehiculos.map((categoria) =>
            <option key={categoria.Id} value={categoria.Id}>{categoria.Nombre}</option>
        );
    */
    const optionsVehiculos = carOption;


    const onChangeType = (event) => {
        const value = event.target.value;
        setIdCategoria(value);

        changeCar(stepForm, value);

    };
    console.log(categoriasVehiculos);
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h2>ESCOGE TU VEHÍCULO</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "30px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="input-group mb-2">
                        <Label name="TIPO" />
                        <select component="select" value={idCategoria} onChange={onChangeType}>
                            {optionsVehiculos}
                        </select>
                    </div>
                </div>
            </div>
            <div className="box-vehicles">
            {
                categoriasVehiculos.length > 0 &&
                categoriasVehiculos.find(w => w.Id === idCategoria).Vehiculos
                    .filter(veh => {
                    if (!FechaRecepcion || !FechaDevolucion) return true;

                    const bloqueoDesde = veh.BloqueoDesde ? new Date(veh.BloqueoDesde) : null;
                    const bloqueoHasta = veh.BloqueoHasta ? new Date(veh.BloqueoHasta) : null;
                    if (bloqueoHasta) {
                        bloqueoHasta.setHours(23, 59, 59, 999); 
                    }
                    if (bloqueoDesde) {
                        bloqueoDesde.setHours(0, 0, 0, 0); 
                    }
                    const recepcion = new Date(FechaRecepcion);
                    const devolucion = new Date(FechaDevolucion);

                    if (!bloqueoDesde || !bloqueoHasta) return true;

                    // El vehículo está bloqueado si alguna de las fechas seleccionadas cae en el rango
                    const estaBloqueado =
                        (recepcion >= bloqueoDesde && recepcion <= bloqueoHasta) ||
                        (devolucion >= bloqueoDesde && devolucion <= bloqueoHasta) ||
                        (recepcion <= bloqueoDesde && devolucion >= bloqueoHasta);

                    return !estaBloqueado;
                    })
                    .map(veh => (
                    <RowVehiculo
                        key={veh.Id}
                        categoria={categoriasVehiculos.find(w => w.Id === idCategoria)}
                        vehiculo={veh}
                    />
                    ))
                }
            </div>
            <div className="row">
                <div className="col-md-12 box-buttons">
                    <button onClick={() => bindReset()} className="btn btn-interamerican">ANTERIOR</button>
                    {showSiguiente && (
                        <button onClick={() => vehiculo.Id && stepFoward()} className="btn btn-interamerican">
                            SIGUIENTE
                        </button>
                    )}
                   
                </div>
            </div>
        </>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        stepBackward: () => {
            dispatch(changeStepForm({ stepForm: STEPS.COBERTURAS }));
            window.scrollTo(0, 0);
        },
        stepFoward: () => {
            dispatch(changeStepForm({ stepForm: STEPS.COBERTURAS }));
            window.scrollTo(0, 0);
        },
        bindReset: () => {
            dispatch(reset())
            dispatch(resetForm("FormDataCliente"))
        },
        changeCar: (stepForm, value) => {

            dispatch(changeTypeCar(value));
        },
        disabledRedirect: (booleanRedirect) => {
            dispatch(changeTypeRedirect(booleanRedirect));
        },
        isLoading: value => dispatch(isLoading(value))
    }
}

export default connect(null, mapDispatchToProps)(FormVehiculos);